/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_SoftphoneInputs */

const en_settings_tab_softphone = /** @type {(inputs: Settings_Tab_SoftphoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone`)
};

const de_settings_tab_softphone = /** @type {(inputs: Settings_Tab_SoftphoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone`)
};

/**
* | output |
* | --- |
* | "Softphone" |
*
* @param {Settings_Tab_SoftphoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_tab_softphone = /** @type {((inputs?: Settings_Tab_SoftphoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_SoftphoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tab_softphone(inputs)
	return de_settings_tab_softphone(inputs)
});